<template>
  <div class="Period">
    <div
      class="period-content clearfix"
      :class="{ opacity: period.limit }"
      @click="handleDate(period)"
    >
      <!-- 暂只维护 2: 大班课, 5: 点播课, 10: 图文课, 16:双师课, 23:互动课"-->
      <template v-if="[2, 5, 10, 16, 23].includes(periodsType)">
        <div class="left">
          <div v-if="period.limit" class="limitDiv">限制访问</div>
          <div
            class="period-title-wrapper"
            :class="{
              disabled: !$services.CourseService.checkLiveState(periodsType, period),
            }"
            @click="targetPeriod"
          >
            <CoursePeriodsType :periods_type="periodsType" :short="true"></CoursePeriodsType>
            <span class="period-title" :title="period.periods_title">
              {{ period.periods_title
              }}<span v-if="showTitleLastViewed" class="last-viewed"> 上次学到 </span>
            </span>
          </div>
          <!-- play_type: 6: 未预约，针对互动课 -->
          <!-- 互动课state -->
          <div class="period-state" v-if="periodsType === 23">
            <template v-if="period.play_type === 6">
              <span class="no-date">未预约，请联系辅导老师预约上课时间哦～</span>
            </template>
            <template v-else>
              <span v-if="period.start_play">
                {{ period.start_play + '-' + period.end_play }}
              </span>
              <template>
                <div v-if="period.play_type === 1" class="state notStart">
                  <img src="@/assets/images/course/time_line.png" />
                  未开课
                </div>
                <div v-if="period.play_type === 2" class="state inClass">
                  <img src="@/assets/images/course/inClass.gif" />
                  上课中
                </div>
                <div v-if="[3, 4, 5].includes(period.play_type)" class="state end">
                  <img src="@/assets/images/course/correct_line.png" />
                  已开课
                </div>
              </template>
            </template>
          </div>
          <div class="period-state" v-else-if="[2, 16].includes(periodsType)">
            <span v-if="period.start_play">
              {{ period.start_play + '-' + period.end_play }}
            </span>
            <template>
              <div v-if="period.play_type === 1" class="state notStart">
                <img src="@/assets/images/course/time_line.png" />
                未开课
              </div>
              <div v-if="period.play_type === 2" class="state inClass">
                <img src="@/assets/images/course/inClass.gif" />
                上课中
              </div>
              <div v-if="[3, 4, 5].includes(period.play_type)" class="state end">
                <img src="@/assets/images/course/correct_line.png" />
                已开课
              </div>
            </template>
          </div>
          <div class="serve-warp">
            <div
              v-if="period.homework"
              class="homework-tip"
              v-html="getHomeworkTip(period.homework)"
            />
            <div class="serve-items">
              <div
                v-if="period.homework"
                class="serve-item"
                @click="handleGoHomework(period.homework)"
              >
                <svg
                  width="16"
                  height="17"
                  viewBox="0 0 16 17"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g id="file_paper_line ">
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M9.36766 2.30078L13.3337 6.26678V13.6341C13.3337 14.7341 12.4337 15.6341 11.3337 15.6341H4.66699C3.56699 15.6341 2.66699 14.7341 2.66699 13.6341V4.30078C2.66699 3.20078 3.56699 2.30078 4.66699 2.30078H9.36766ZM8.00033 3.63411H4.66699C4.30566 3.63411 4.00033 3.93945 4.00033 4.30078V13.6341C4.00033 13.9954 4.30566 14.3008 4.66699 14.3008H11.3337C11.695 14.3008 12.0003 13.9954 12.0003 13.6341V7.63411H8.66699C8.29833 7.63411 8.00033 7.33611 8.00033 6.96745V3.63411ZM7.33366 10.9674C7.70185 10.9674 8.00033 11.2659 8.00033 11.6341C8.00033 12.0023 7.70185 12.3008 7.33366 12.3008H6.00033C5.63214 12.3008 5.33366 12.0023 5.33366 11.6341C5.33366 11.2659 5.63214 10.9674 6.00033 10.9674H7.33366ZM10.0003 8.96745C10.3685 8.96745 10.667 9.26592 10.667 9.63411C10.667 10.0023 10.3685 10.3008 10.0003 10.3008H6.00033C5.63214 10.3008 5.33366 10.0023 5.33366 9.63411C5.33366 9.26592 5.63214 8.96745 6.00033 8.96745H10.0003ZM9.33366 4.15278V6.30078H11.4817L9.33366 4.15278Z"
                      fill="currentColor"
                      fill-opacity="0.9"
                    />
                  </g>
                </svg>
                <span>课后作业</span>
              </div>
              <div
                v-if="period.report_status"
                class="serve-item"
                @click="handleGoStudyReport(period.report_status)"
              >
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g id="evaluation_line">
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M10 1.33203C10.3682 1.33203 10.6667 1.63051 10.6667 1.9987H12C13.1046 1.9987 14 2.89413 14 3.9987V12.6654C14 13.7699 13.1046 14.6654 12 14.6654H4C2.89543 14.6654 2 13.7699 2 12.6654V3.9987C2 2.89413 2.89543 1.9987 4 1.9987H5.33333C5.33333 1.63051 5.63181 1.33203 6 1.33203H10ZM5.33333 3.33203H4C3.63181 3.33203 3.33333 3.63051 3.33333 3.9987V12.6654C3.33333 13.0336 3.63181 13.332 4 13.332H12C12.3682 13.332 12.6667 13.0336 12.6667 12.6654V3.9987C12.6667 3.63051 12.3682 3.33203 12 3.33203H10.6667L10.6622 3.40978C10.6237 3.74134 10.3419 3.9987 10 3.9987H6C5.63181 3.9987 5.33333 3.70022 5.33333 3.33203ZM10 10.6654C10.3682 10.6654 10.6667 10.9638 10.6667 11.332C10.6667 11.7002 10.3682 11.9987 10 11.9987H6C5.63181 11.9987 5.33333 11.7002 5.33333 11.332C5.33333 10.9638 5.63181 10.6654 6 10.6654H10ZM10.3235 5.42239C10.5839 5.68274 10.5839 6.10485 10.3235 6.3652L7.49509 9.19362C7.23474 9.45397 6.81263 9.45397 6.55229 9.19362L5.60948 8.25081C5.34913 7.99047 5.34913 7.56835 5.60948 7.30801C5.86983 7.04766 6.29194 7.04766 6.55229 7.30801L7.02369 7.77941L9.38071 5.42239C9.64106 5.16204 10.0632 5.16204 10.3235 5.42239Z"
                      fill="currentColor"
                    />
                  </g>
                </svg>
                <span>学习报告</span>
              </div>
            </div>
          </div>
          <PeriodFileList
            v-if="[5, 10]"
            ref="fileList"
            :period="period"
            :isViewedReport="isDatumViewedReport"
            :checkAvailableFunction="checkAvailable"
          />
        </div>
        <div class="period-btn" v-if="periodsType === 23">
          <div v-if="period.play_type !== 6" @click.stop="goToTask(period)" class="btn">去学习</div>
        </div>
        <div class="period-btn" v-if="[2, 16].includes(periodsType)">
          <div v-if="[3, 4, 5].includes(period.play_type)" @click.stop="targetPeriod" class="btn">
            查看回放
          </div>
          <div v-if="period.play_type === 1" @click.stop="targetPeriod" class="btn disabled">
            进入教室
          </div>
          <div v-if="period.play_type === 2" @click.stop="targetPeriod" class="btn">进入教室</div>
        </div>
      </template>
    </div>
    <CourseContentTip
      v-if="showContentDialog"
      :show.sync="showContentDialog"
      :content="chapter_content"
    ></CourseContentTip>
    <CourseSoldOutTip v-if="showSoldOut" :show.sync="showSoldOut"></CourseSoldOutTip>
    <ContactTeacherDialog
      :visible="showContactTeacherDialog"
      :interceptText="period.interception_info?.interceptText.split('_')[0]"
      :wechatWorkQrCode="period.interception_info?.wechat_work_qr_code"
      @close="showContactTeacherDialog = false"
    />
    <el-dialog title="添加辅导老师" :visible.sync="assiModal" width="30%" class="add-assi">
      <img
        :src="course.assistant_teacher && course.assistant_teacher.wechat_work_qr_code"
        class="assit-img"
        alt=""
      />
      <span slot="footer" class="dialog-footer"></span>
    </el-dialog>
  </div>
</template>
<script>
import CourseSoldOutTip from '@/modules/stu/components/CourseSoldOutTip.vue';
import PeriodFileList from './PeriodFileList';
import CoursePeriodsType from '@/modules/stu/components/CoursePeriodsType';
import CourseContentTip from '@/modules/stu/components/CourseContentTip';
import ContactTeacherDialog from '@/modules/stu/components/ContactTeacherDialog';

export default {
  name: 'Period',
  components: {
    CourseSoldOutTip,
    PeriodFileList,
    CoursePeriodsType,
    CourseContentTip,
    ContactTeacherDialog,
  },
  props: {
    period: {
      type: Object,
    },
    course_id: {
      type: Number,
    },
    course_title: {
      type: String,
      default: '',
    },
    course: {
      type: Object,
      default: () => {
        return {};
      },
    },
    isDatumViewedReport: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      showContactTeacherDialog: false,
      showContentDialog: false,
      chapter_content: '',
      showSoldOut: false,
      assiModal: false,
    };
  },
  computed: {
    commonSetting() {
      return this.$store.state.commonSetting;
    },
    periodsType() {
      return this.period.periods_type;
    },
    //点播课标题是否展示上次学到
    showTitleLastViewed() {
      return (
        this.periodsType == 5 &&
        this.isDatumViewedReport &&
        this.period.is_last_time_viewed === 1 &&
        (!this.period.datum || this.period.datum.every((item) => item.is_last_time_viewed !== 1))
      );
    },
  },
  watch: {
    'period.report_status': function () {
      if (this.period.report_status) {
        this.$webSeeSendTrack({
          event_id: 'study_report_entrance_show',
          event_type: 'show',
          data: {
            course_id: this.course_id,
            course_title: this.course_title,
            course_type: this.period.course_type,
            periods_id: this.period.periods_id,
            periods_title: this.period.periods_title,
          },
        });
      }
    },
  },
  methods: {
    handleDate() {
      if (this.period.play_type === 6) {
        // 未预约
        if (this.course.assistant_teacher && this.course.assistant_teacher.wechat_work_qr_code) {
          this.assiModal = true;
        } else {
          this.$message.warning('请添加辅导老师预约时间哦');
        }
      }
    },
    goToTask(period) {
      this.$router.push({
        name: 'MemberStudyTask',
        query: { d: period.start_play_timestamp },
      });
    },
    handleGoHomework(homework) {
      if (homework.status === 0) {
        this.$info('作业未解锁');
        return;
      }
      sessionStorage.setItem('backRouter', 'MemberStudy');
      sessionStorage.setItem('memberCourseId', this.course_id);
      if ([1, 11].includes(homework.status)) {
        this.$router.push({
          name: homework.status === 11 ? 'HomeworkDo' : 'HomeworkIntro',
          query: {
            id: homework.report_id,
            hw_id: homework.hw_id,
          },
        });
        return;
      }
      this.$router.push({
        name: 'HomeworkAnalysis',
        query: {
          id: homework.report_id,
          hw_id: homework.hw_id,
          type: homework.status === 6 ? 'correct' : undefined,
        },
      });
    },
    handleGoStudyReport(reportStatus) {
      this.$webSeeSendTrack({
        event_id: 'study_report_entrance_click',
        event_type: 'click',
        data: {
          course_id: this.course_id,
          course_title: this.course_title,
          course_type: this.period.course_type,
          periods_id: this.period.periods_id,
          periods_title: this.period.periods_title,
          status: reportStatus.status, // 0 未生成 1 未查看 2 已查看
          short_link_code: reportStatus.short_link_code, // 报告码
        },
      });

      if (reportStatus.status === 0) {
        this.$info('报告未生成');
        return;
      }
      window.open(`/h5/study_report?id=${reportStatus.short_link_code}`, '_blank');
    },
    getHomeworkTip(item) {
      // 0待解锁 1待提交「开始作答」「继续作答」、2待批改「答题情况」、6待订正「作答结果」、7已完成「查看结果」。
      const tipMap = {
        0: '开课后解锁作业',
        1: '快来验证一下学习效果吧',
        11: '加把劲儿，就快答完了',
        2: '快马加鞭批改中...',
        6: `你找到了<span style="color: red">${item.number}道错题</span>，快去订正吧`,
        7: '恭喜你完成本次作业',
      };
      const status = item.status;
      return tipMap[status];
    },
    //课程可用性检测（限制访问、过期、冻结等）（点击课程附件列表组件会在此校验课程可用性）
    async checkAvailable() {
      if (this.period.interception_info) {
        this.showContactTeacherDialog = true;
        return false;
      }

      this.$webSeeSendTrack({
        event_id: 'my_courses_item_detail_click',
        event_type: 'click',
        data: {
          course_id: this.course_id,
          course_title: this.course_title,
          course_type: this.period.course_type,
        },
      });

      if (this.period.limit) {
        this.$info('访问被限制，请联系老师');
        return false;
      }

      if (this.course.status == 2 && this.course.is_go_to_study == 0) {
        this.showSoldOut = true;
        return false;
      }

      /*
      if (this.period.bjy_encode_status != 1) {
        this.$info("视频转码中，请稍后观看");
        return false;
      }
      */

      if (!this.$services.CourseService.checkLiveState(this.periodsType, this.period)) {
        return false;
      }

      if (this.course.valid_status != 1) {
        this.$info('该课程已过期，无法继续学习');
        return false;
      }

      await this.$services.CourseService.checkLimit(this.course_id, this.period.id); //旧代码逻辑（暂不改变）：验证失败时Promise阻塞于此,以实现点击事件业务逻辑执行中断

      return true;
    },

    async targetPeriod() {
      if (this.period.play_type === 6) {
        return;
      }
      if (await this.checkAvailable()) {
        //图文课
        if (this.periodsType == 10) {
          if (this.period?.datum?.length > 0) {
            // 预览图文课的第一个文件
            this.$refs.fileList?.onPreviewFirstFile();
            return;
          }
          let data = await this.$services.CourseService.getPeriodContent(this.period);
          this.chapter_content = data.course_content;
          this.showContentDialog = true;
        } else {
          //点播课标题（视频）点击上报
          if (this.periodsType == 5 && this.isDatumViewedReport) {
            await this.$http.post('/api/app/myStudy/report', {
              type: 0, //0: 表示点播课(无附件) 1: 表示资料（附件)
              course_basis_id: this.course_id,
              course_chapter_id: this.period?.course_chapter_id,
              datum_id: undefined, // type=0时，该字段可以不传或传0
            });
          }

          await this.$services.CourseService.watchVideo(
            this.period,
            this.periodsType,
            this.course_id,
          );
        }
      }
    },
  },
};
</script>
<style scoped lang="scss">
.add-assi {
  ::v-deep .el-dialog__header {
    text-align: center;
  }
  ::v-deep .el-dialog__body {
    text-align: center;
    max-height: none;
  }
  .assit-img {
    width: 150px;
  }
}
.Period {
  &:last-child {
    margin-bottom: 0;
  }
  .period-content {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 16px 12px;
    border-bottom: 1px solid #f3f3f3;
    &.opacity {
      opacity: 0.5;
    }
  }
  .left {
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 8px;
    .limitDiv {
      position: absolute;
      right: 10px;
      top: -10px;
      color: #9a9a9a;
      font-size: 14px;
    }
    .period-title-wrapper {
      display: flex;
      align-items: center;
      cursor: pointer;
      &:hover {
        .period-title {
          color: $primary-color;
        }
      }
      &.disabled {
        cursor: default;
      }
      .period-title {
        display: flex;
        align-items: center;
        flex: 1;
        font-size: 16px;
        font-weight: 500;
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
        width: 0;
        color: #1a1a1a;
        .last-viewed {
          display: inline-block;
          padding: 2px 4px;
          border-radius: 4px;
          margin-left: 16px;
          font-size: 12px;
          line-height: 17px;
          background: #f0f3fc;
          font-size: 10px;
          line-height: 14px;
          color: #f55;
          background: #ffefec;
        }
      }
    }
    .period-state {
      font-size: 14px;
      line-height: 20px;
      display: flex;
      align-items: center;
      padding: 2px 0;
      font-size: 14px;
      line-height: 20px;
      color: #666666;
      .no-date {
        line-height: 22px;
        font-size: 14px;
        color: #999;
      }
      .state {
        font-size: 14px;
        line-height: 20px;
        display: flex;
        align-items: center;
        margin-left: 24px;
        img {
          width: 16px;
          height: 16px;
          display: block;
          margin-right: 8px;
        }
      }
      .notStart {
        color: #666;
      }
      .inClass {
        color: #ff5858;
      }
      .end {
        color: #000;
      }
    }
    .serve-warp {
      .homework-tip {
        padding-bottom: 8px;
        font-size: 14px;
        line-height: 20px;
        color: #999;
      }
      .serve-items {
        display: flex;
        .serve-item {
          font-size: 14px;
          line-height: 20px;
          // padding-top: 18px;
          display: flex;
          align-items: center;
          color: #333;
          cursor: pointer;
          span {
            margin-left: 4px;
          }
          &::before {
            content: '';
            display: inline-block;
            margin: 0 16px;
            width: 1px;
            height: 12px;
            background: #d9d9d9;
          }
          &:first-child {
            &::before {
              display: none;
            }
          }
        }
        .serve-item:hover {
          color: #ff4242;
        }
      }
    }
  }
  .period-btn {
    flex-shrink: 0;
    padding-left: 10px;
    .btn {
      padding: 10px 24px;
      font-size: 14px;
      line-height: 20px;
      font-weight: 500;
      border-radius: 30px;
      background: #ff4242;
      box-shadow: 0px 0px 4px -2px rgba(24, 39, 75, 0.12), 0px 0px 4px -2px rgba(24, 39, 75, 0.08);
      color: #fff;
      cursor: pointer;
    }
    .disabled {
      background: #d0d0d8;
      box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.2);
    }
  }
}
</style>
